<template>
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.87 20.823c.478.016.952.092 1.411.226 3.618 1.033 3.817 1.15 4.775 1.15h4.441a5.421 5.421 0 0 0 3.657-1.394 5.438 5.438 0 0 0 1.77-3.497l.271-4.62a4.073 4.073 0 0 0-.792-2.632 4.06 4.06 0 0 0-2.283-1.525c-.977-.245-2.343-.245-2.343-1.613v-3.08A2.04 2.04 0 0 0 14.744 1.8a2.034 2.034 0 0 0-2.035 2.038c0 .09.597 8.198-6.784 8.198l-.054 8.787ZM5.87 9.953H1.8v12.229h4.07V9.952Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
